const PermissionType = {
  GRP: { id: 'GRP', name: 'Grupo' },
  USR: { id: 'USR', name: 'Usuário' }
}

Object.freeze(PermissionType)

export default PermissionType
